export function setPageTitle(title) {
  document.title = title ? `${title} · Arkii` : "Arkii";
}
